// extracted by mini-css-extract-plugin
export default {"dayOpeningHoursContainer":"OpeningHoursPicker_dayOpeningHoursContainer__xRsm+","day":"OpeningHoursPicker_day__RVM6W","hours":"OpeningHoursPicker_hours__58lW2"};